import React, { useContext } from "react";
import { Grid, Typography } from "@mui/material";
import Card from "components/ui/Card";
import { useLocation, useNavigate } from "react-router-dom";
import { encodeStr } from "utils/encodeDecodeStr";
import SortContext from "context/SortContext";

const StockDesign = ({ category }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { search } = useContext(SortContext);

  const handleNavigate = (category) => {
    const state = {
      ...location.state,
      name: [`${category.category} Stock`],
      categoryName: category.category,
      stockSearch: search !== "" ? search : "",
      subStockSearch: "",
    };

    navigate(`/Stock/${encodeStr(category.category)}`, { state });
  };

  return (
    <Card style={{ minWidth: 275, maxWidth: "317px", height: 62, borderRadius: "5px" }} onClick={() => handleNavigate(category)}>
      <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
        {category.category}
      </Typography>
      <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
        {category.count}
      </Typography>
    </Card>
  );
};

export default StockDesign;
